import * as S from './styles.ts';
import { ChevronRight } from '@template/icons';
import { ColorKey } from '@template/theme/types/color.type.ts';
import { UniversalLink } from '@template/components';

export interface ICtaLinkProps {
  href: string;
  linkText: string;
  color: ColorKey;
  withIcon?: boolean;
  target?: '_blank';
}

const CtaLink = ({
  href,
  linkText,
  color = 'primary',
  withIcon = true,
  target,
}: ICtaLinkProps) => {
  return (
    <UniversalLink href={href} {...{ target: target }}>
      <S.CtaLink $color={color}>
        {linkText}
        {withIcon && <ChevronRight />}
      </S.CtaLink>
    </UniversalLink>
  );
};

export default CtaLink;
